import { Component, inject, signal } from '@angular/core';
import {
	MAT_DIALOG_DATA,
	MatDialogActions,
	MatDialogClose,
	MatDialogContent,
	MatDialogRef,
	MatDialogTitle,
} from '@angular/material/dialog';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { WORKPLACE_SERVICE, WorkplaceService } from '../../../../api/services/workplace.api';
import { Workplace } from '../../../../api/app-types/workplace.app';
import { NOTIFICATION_SERVICE } from '../../../../shared/notification/notification';
import {
	createErrorNotification,
	createSuccessNotification,
} from '../../../../shared/notification/notification.factory';
import { LvrButton } from '../../../../core/components/lvr-button/lvr-button';

@Component({
	selector: 'lvr-institution-workplace-delete-dialog',
	imports: [MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose, TranslocoPipe, LvrButton],
	providers: [
		{
			provide: WORKPLACE_SERVICE,
			useClass: WorkplaceService,
		},
	],
	templateUrl: './institution-workplace-delete-dialog.html',
})
export class InstitutionWorkplaceDeleteDialog {
	private readonly api = inject(WORKPLACE_SERVICE);
	private readonly ntfySrv = inject(NOTIFICATION_SERVICE);
	private readonly transloco = inject(TranslocoService);
	private readonly dialogRef = inject(MatDialogRef<InstitutionWorkplaceDeleteDialog>);
	private readonly data: { workplace: Workplace; institutionId: number; onDeleted: () => Promise<void> } =
		inject(MAT_DIALOG_DATA);
	public readonly workplace = this.data.workplace;
	public readonly loading = signal(false);

	public async deleteWorkplace() {
		if (this.loading()) return;

		this.loading.set(true);

		try {
			await this.api.delete(this.data.institutionId, this.data.workplace.id!);
			await this.data.onDeleted();
			this.ntfySrv.addNotification(
				createSuccessNotification(this.transloco.translate('base.notification_message.workplace_deleted')),
			);
			this.dialogRef.close(true);
		} catch {
			this.ntfySrv.addNotification(
				createErrorNotification(this.transloco.translate('base.notification_message.workplace_delete_error')),
			);
		} finally {
			this.loading.set(false);
		}
	}
}
